<div class="main-container-position">
  <div class="container-width">
    <div class="bannerimage"></div>
    <h1 class="text-2xl font-bold my-8" i18n>
      Willkommen bei Sondis – deiner Lebensbegleiterin
    </h1>
    <h3 class="text-lg text-gray-700" i18n>
      Finde auf deine Bedürfnisse abgestimmte und regionale Neuigkeiten und
      Angebote rund um die Themen Betreuung, Pflege und Gesundheit.
    </h3>

    <div class="bg-green-50 border-l-4 border-green-400 p-4 my-8">
      <div class="flex items-center">
        <span class="material-symbols-outlined text-green-500 mr-3">info</span>
        <p class="text-gray-700">
          Unsere Plattform wächst! <br />
          Wir arbeiten kontinuierlich daran, neue Angebote hinzuzufügen und
          immer mehr Regionen sowie Anbieter einzubinden. <br />
          Schau regelmäßig vorbei – es kommt ständig etwas Neues dazu!
        </p>
      </div>
    </div>
    @if ((showTrending$ | async) === true) {
      <div class="container mx-auto mb-12" data-testid="trending-section">
        <p
          class="text-2xl font-bold mt-8 mb-4"
          i18n
          data-testid="trending-headline"
        >
          Trend-Kategorien
        </p>
        @if (isLoading$ | async) {
          <div>
            <app-skeleton-loading
              [showLoadingText]="true"
              [loadingText]="'Angebote werden geladen...'"
              [showTabs]="true"
              [numberOfTabs]="4"
              [numberOfCards]="6"
              [containerClass]="'bg-gray-100 p-6 rounded-lg'"
              [gridClass]="'flex flex-wrap gap-2'"
            ></app-skeleton-loading>
          </div>
        } @else {
          @if (parentCategories$ | async; as parentCategories) {
            <!-- Desktop view with tabs -->
            @if (!isMobileView) {
              <div class="hidden sm:block">
                <ul
                  class="!list-none flex flex-wrap space-y-2 md:space-y-0 bg-gray-100 sm:bg-transparent pt-4 sm:pt-0 rounded-t-lg"
                  data-testid="trending-category-tab"
                >
                  @for (
                    category of parentCategories;
                    track category;
                    let i = $index
                  ) {
                    <li class="cursor-pointer mb-2">
                      <a
                        href="#"
                        (click)="
                          onCategorySelect(category.id, i);
                          $event.preventDefault()
                        "
                        [ngClass]="{
                          'bg-gray-100': selectedTab === i,
                          'bg-transparent': selectedTab !== i,
                          'underline sm:no-underline': selectedTab === i,
                        }"
                        class="transition duration-300 px-6 py-2 text-gray-800 sm:rounded-t-md font-medium sm:pb-5"
                        [attr.data-testid]="'trending-category-tab-' + i"
                      >
                        {{ category.name }}
                      </a>
                    </li>
                  }
                </ul>
                <div class="bg-gray-100 p-6 rounded-lg">
                  @if (filteredOffers$ | async; as filteredOffers) {
                    @if (filteredOffers.length > 0) {
                      <div
                        class="flex flex-wrap gap-2"
                        data-testid="trending-offers-grid"
                      >
                        @for (offer of filteredOffers; track offer) {
                          <app-offer-card
                            class="max-w-[231px] w-full"
                            [offer]="offer"
                            [showStatus]="false"
                            [showActions]="false"
                            data-testid="trending-offer-card"
                          ></app-offer-card>
                        }
                      </div>
                    } @else {
                      <ng-container
                        [ngTemplateOutlet]="noOffers"
                      ></ng-container>
                    }
                  } @else {
                    <ng-container [ngTemplateOutlet]="noOffers"></ng-container>
                  }
                </div>
              </div>
            }
            <!-- Mobile view with expansion panels -->
            @if (isMobileView) {
              <div class="block sm:hidden">
                <mat-accordion class="w-full">
                  @for (
                    category of parentCategories;
                    track category;
                    let i = $index
                  ) {
                    <mat-expansion-panel
                      class="mb-2 shadow-none"
                      (afterExpand)="onCategorySelect(category.id, i)"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{ category.name }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div>
                        @if (filteredOffers$ | async; as filteredOffers) {
                          @if (filteredOffers.length > 0) {
                            <div class="grid grid-cols-1 gap-2">
                              @for (
                                offer of getTopThreeOffers(filteredOffers);
                                track offer
                              ) {
                                <app-offer-card
                                  class="max-w-[231px] w-full"
                                  [offer]="offer"
                                  [showStatus]="false"
                                  [showActions]="false"
                                ></app-offer-card>
                              }
                            </div>
                            <div class="mt-4 text-center">
                              <a
                                [routerLink]="['/search']"
                                [queryParams]="{ tags: category.name }"
                                class="text-blue-600 hover:text-blue-800"
                              >
                                Mehr anzeigen
                              </a>
                            </div>
                          } @else {
                            <ng-container
                              [ngTemplateOutlet]="noOffers"
                            ></ng-container>
                          }
                        } @else {
                          <ng-container
                            [ngTemplateOutlet]="noOffers"
                          ></ng-container>
                        }
                      </div>
                    </mat-expansion-panel>
                  }
                </mat-accordion>
              </div>
            }
          }
        }
        <ng-template #noOffers>
          <p class="text-gray-600 text-center" i18n>
            Keine Angebote in dieser Kategorie verfügbar.
          </p>
        </ng-template>
      </div>
    }

    <!-- User's Personal Recommendations Section -->
    @if (isLoggedIn) {
      <div class="container mx-auto mb-12">
        @if (user$ | async; as user) {
          @if (userOffers$ | async; as userOffers) {
            @if (userOffers.length > 0) {
              <h1 class="text-2xl font-bold my-12" i18n>
                Empfehlungen für dich
              </h1>
              <div class="mb-8">
                <div class="flex items-center gap-4 mb-4">
                  <div class="flex items-center gap-2 min-w-fit">
                    @if (user?.profilePicture?.url) {
                      <img
                        [src]="user?.profilePicture?.url"
                        alt="Profile picture"
                        class="w-12 h-12 rounded-full object-cover"
                      />
                    } @else {
                      <div
                        class="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center"
                      >
                        <span class="material-symbols-outlined text-gray-400"
                          >person</span
                        >
                      </div>
                    }
                  </div>
                  <div>
                    <h2
                      class="text-xl font-semibold m-0"
                      data-testid="user-headline"
                    >
                      {{ user?.firstName }} {{ user?.lastName }}
                    </h2>
                    <div class="flex flex-wrap gap-2 mt-2">
                      @for (
                        category of user?.categories || [];
                        track category
                      ) {
                        <div
                          class="px-3 py-1 rounded-full text-sm bg-green-100"
                        >
                          {{ category.name }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="bg-gray-100 p-6 rounded-lg">
                  <div
                    class="flex flex-wrap gap-2"
                    data-testid="user-offers-grid"
                  >
                    @for (offer of getTopOffers(userOffers); track offer) {
                      <app-offer-card
                        class="max-w-[231px] w-full"
                        [offer]="offer"
                        [showStatus]="false"
                        [showActions]="false"
                        data-testid="user-offer-card"
                      ></app-offer-card>
                    }
                    @if (userOffers.length > 6) {
                      <div
                        class="max-w-[231px] w-full flex justify-center items-center"
                      >
                        <a
                          [routerLink]="['/search']"
                          [queryParams]="{
                            tags: getUserCategoriesAsQueryParam(user!),
                          }"
                          class="inline-flex items-center gap-3 bg-white border border-gray-200 rounded-lg px-6 py-3 hover:bg-gray-50 transition-colors duration-200 shadow-lg max-h-fit"
                        >
                          <div>
                            <p class="text-gray-800 font-medium" i18n>
                              Alle Angebote anzeigen
                            </p>
                            <p class="text-sm text-gray-500 mt-1" i18n>
                              {{ userOffers.length - 6 }} weitere Angebote
                            </p>
                          </div>
                          <span class="material-symbols-outlined text-blue-500"
                            >arrow_forward</span
                          >
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          }
        }
      </div>
    }

    <!-- Managed Users Recommendations Section -->
    @if (isLoggedIn) {
      <div class="container mx-auto mb-12" data-testid="managed-users-section">
        @if (managedUsers$ | async; as managedUsers) {
          @if (managedUsers.length > 0) {
            <h1 class="text-2xl font-bold my-12" i18n>
              Empfehlungen für deine Angehörigen
            </h1>
            @for (user of managedUsers; track user) {
              <div class="mb-8">
                <div class="flex items-center gap-4 mb-4">
                  <div class="flex items-center gap-2 min-w-fit">
                    @if (user.profilePicture?.url) {
                      <img
                        [src]="user.profilePicture!.url"
                        alt="Profile picture"
                        class="w-12 h-12 rounded-full object-cover"
                      />
                    } @else {
                      <div
                        class="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center"
                      >
                        <span class="material-symbols-outlined text-gray-400"
                          >person</span
                        >
                      </div>
                    }
                  </div>
                  <div>
                    <h2
                      class="text-xl font-semibold m-0"
                      data-testid="managed-user-headline"
                    >
                      {{ user.firstName }} {{ user.lastName }}
                    </h2>
                    <div class="flex flex-wrap gap-2 mt-2">
                      @for (category of user.categories; track category) {
                        <div
                          class="px-3 py-1 rounded-full text-sm bg-green-100"
                        >
                          {{ category.name }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
                @if (managedUserOffers$ | async; as managedUserOffers) {
                  @if (user.id && managedUserOffers[user.id].length > 0) {
                    <div class="bg-gray-100 p-6 rounded-lg">
                      <div
                        class="flex flex-wrap gap-2"
                        data-testid="managed-user-offers-grid"
                      >
                        @for (
                          offer of getTopOffers(managedUserOffers[user.id!]);
                          track offer
                        ) {
                          <app-offer-card
                            class="max-w-[231px] w-full"
                            [offer]="offer"
                            [showStatus]="false"
                            [showActions]="false"
                            data-testid="managed-user-offer-card"
                          ></app-offer-card>
                        }
                        @if (managedUserOffers[user.id].length > 6) {
                          <div
                            class="max-w-[231px] w-full flex justify-center items-center"
                          >
                            <a
                              [routerLink]="['/search']"
                              [queryParams]="{
                                tags: getManagedUserCategoriesAsQueryParam(
                                  user
                                ),
                              }"
                              class="inline-flex items-center gap-3 bg-white border border-gray-200 rounded-lg px-6 py-3 hover:bg-gray-50 transition-colors duration-200 shadow-lg max-h-fit"
                            >
                              <div>
                                <p class="text-gray-800 font-medium" i18n>
                                  Alle Angebote anzeigen
                                </p>
                                <p class="text-sm text-gray-500 mt-1" i18n>
                                  {{ managedUserOffers[user.id].length - 6 }}
                                  weitere Angebote
                                </p>
                              </div>
                              <span
                                class="material-symbols-outlined text-blue-500"
                                >arrow_forward</span
                              >
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  } @else {
                    <div class="bg-gray-100 p-6 rounded-lg">
                      <p class="text-gray-600 text-center" i18n>
                        Keine passenden Angebote für
                        {{ user.firstName }} gefunden.
                      </p>
                    </div>
                  }
                }
              </div>
            }
          }
        }
      </div>
    }
    <ng-template #noManagedUsers></ng-template>
    <div
      class="w-full max-w-2xl mx-auto bg-white border border-gray-200 rounded-lg shadow-md px-8 pb-8 text-center"
    >
      <h2 class="text-lg font-semibold text-gray-800" i18n>
        Entdecke Sondisa, deine KI-Assistentin, die dich bei deiner Suche
        unterstützt.
      </h2>
      <img
        src="assets/sondisa_logo.png"
        alt="Sondisa Logo"
        class="w-48 h-auto mx-auto mt-6 mb-4"
      />
      <h3 class="text-2xl font-bold text-gray-800 mb-4" i18n>
        Wie kann ich dir heute helfen?
      </h3>
      <p class="text-gray-600 mb-6" i18n>
        Frag Sondisa und erhalte Antworten rund um die Themen Gesundheit und
        Pflege.
      </p>
      <button
        class="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-6 rounded-full"
        routerLink="/sondisa"
        i18n
      >
        Chatte jetzt
      </button>
    </div>
  </div>
</div>
